export { default } from './MaterialTypeLink';



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/MaterialTypeLink/index.js